import { Navigate, Outlet } from 'react-router-dom'
import { useCurrentShow } from '@/context/current-show'
import { useShowSlug } from '@/hooks/useShowSlug'
import { showAware } from '@/lib/paths'

export function LabelOnlyAllowed() {
  const { currentShow } = useCurrentShow()
  const currentSlug = useShowSlug()

  if (currentShow?.labelOnlyMode) {
    const target = showAware('/run', { currentSlug })
    return <Navigate to={target} replace />
    // Alternatively, render a blocked notice if needed
    // return <div>Not available in Label‑Only Mode. Go to Dashboard.</div>
  }

  return <Outlet />
}

export default LabelOnlyAllowed
